import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { BaseWebService } from "../shared/services/base-web.service";

@Injectable()
export class ProfileService {
	constructor(
		private _basewebservice: BaseWebService
	) { }

	/** Service To Fetch Cities **/
	getCities = () => {
		return this._basewebservice.request("v1/cities/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	/** Service To Fetch practice details**/
	getPracticeDetails = () => {
		return this._basewebservice.request("v1/practice_update/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	/** Fetching profile details **/
	getProfileDetails() {
		return this._basewebservice.request("v1/profile/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

    /**
    * Submitting updated details
    */
	submitProfileDetails(updatedProfile: any) {
		const data: any = {};
		data.body = updatedProfile;
		return this._basewebservice.requestFormData("v1/profile/", "put", data)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	sendSESVerification(userId: any) {
		const data: any = {};
		return this._basewebservice.requestFormData("v1/user/" + userId + "/ses_verification/", "post", data)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	handleError(error: Response | any) {
		return Observable.throw(error);
	}
}